export default __webpack_public_path__ + "static/media/no_results_found2.33178adf.png";